import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private backendUrl = '';

  constructor() {
    this.defineBackendUrl();
  }

  getModelsUrl(): string {
    return this.backendUrl + 'models/';
  }

  getModelsUserSettingsUrl(): string {
    return this.getModelsUrl() + 'user-settings/';
  }

  getOnboardingUrl(): string {
    return 'https://onboarding.servc.co.il/team/onboarding-system/demo';
  }

  defineBackendUrl(): void {
    const path = window.location.hostname;
    switch (path) {
      case 'localhost': {
        this.backendUrl = 'http://localhost:5001/api/';
        break;
      }
      case 'models.orcainc.com': {
        this.backendUrl = 'https://api.models.orcainc.com/api/';
        break;
      }
      case 'models.qa.orcainc.com': {
        this.backendUrl = 'https://api.models.qa.orcainc.com/api/';
        break;
      }
      case 'models.qa-unit.orcainc.com': {
        this.backendUrl = 'https://api.models.qa-unit.orcainc.com/api/';
        break;
      }
      case 'models.dev.orcainc.com': {
        this.backendUrl = 'https://api.models.dev.orcainc.com/api/';
        break;
      }
      case 'models.pre-prod.orcainc.com': {
        this.backendUrl = 'https://api.models.pre-prod.orcainc.com/api/';
        break;
      }
    }
  }
}
